var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{ref:"ico",staticClass:"image",attrs:{"viewBox":"0 0 100 100"}},[_c('use',{attrs:{"href":_vm.sanitize(_vm.src + '#' + _vm.name)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }